import React, { Component } from 'react';
import './Stucco.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';

import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Stucco extends Component {
  render() {
  return (
    <div class='windowMain'>
      <div class='stuccoHeader'>
        <h1 class="windowTitle">
          Stucco
        </h1>
      </div>
      <div class="visionSect">
         <h2>Stucco Repair</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="windowInfoSect">
        <section class="windowInfo">
          <div>
          <h4>It's time to repair your Stucco</h4>
          <p>Repairing your stucco is essential for preserving both the
          appearance and structural integrity of your home. Over time,
          stucco can crack or become damaged due to shifting foundations,
          weather exposure, or natural wear and tear. If left untreated,
          these cracks can allow moisture to seep into the walls, leading
          to potential water damage, mold growth, and weakening of the
          overall structure. By repairing your stucco, you prevent further
          deterioration and protect the underlying framework of your home.
          <br></br>
          <br></br>
          In addition to preventing damage, stucco repair enhances your home’s
           curb appeal and resale value. Cracked or worn-out stucco can give
            your home an unkempt, aged appearance, while repairs restore the
            clean, smooth look that stucco is known for. Modern stucco repair
            techniques not only fill cracks but can also be tinted or textured
            to match the original finish, ensuring a seamless, fresh look.
             Whether you're preparing to sell or simply want to maintain your
             home’s exterior, repairing your stucco is a cost-effective way
             to keep it looking great and performing well for years to come.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
    <div class="sectionSpacer">
    </div>

  </div>
  )
};
}

export default Stucco;
